'use strict';

var StepSignificantMarketsDirective = function StepSignificantMarketsDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/step-significant-markets.html'),
    controller: 'StepSignificantMarketsController',
    link: function link(scope) {
      scope.$on('scheduleChange:stepEntered', scope.stepEntered);
    }
  };
};
StepSignificantMarketsDirective.$inject = [];
module.exports = StepSignificantMarketsDirective;